import React, { useEffect, useRef, useState } from "react";
import {
	Row,
	Col,
	Table,
	Spin,
	Select,
	DatePicker,
	Space,
	Form,
	message,
	Modal,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import styled from "@emotion/styled";
import { CSVLink } from "react-csv";
import { connect, useSelector } from "react-redux";
import {
	getUserRoleId,
	getSelectedDepartmentId,
	getStatusListFromID,
	getUserInfo,
	getLeaveCategoryList,
	getClientid,
	getUserList,
	getRoleList,
	getMenuList,
} from "redux/selectors";
import { bindActionCreators } from "redux";
import { toggleProcessingModal } from "redux/actions";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import {
	MONTH_LIST,
	APPROVAL_FILTER_TYPES,
	STATUS_CODE,
} from "common/Constants";
import {
	addDaysinDate,
	addMonthinDate,
	dateInDetail,
	getinitialdate,
	getKenyanDateTime,
	getMonthDateRange,
	getMySqlDate,
	momentDate,
} from "utils/Date";
import COLORS from "common/Colors";
import { find, get, includes, reduce, concat, result, orderBy } from "lodash";
import ViewMore from "organisms/ViewMore";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import ApplyWorkFromHome from "pages/WorkFromHome/ApplyWorkFromHome";
import SuccessDeclinePopup from "reusableComponent/Popup/SuccessDeclinePopup";
import ViewDocument from "reusableComponent/Popup/viewDocument";
import { CloseOutlined } from "@ant-design/icons";
import { ReactComponent as Edit } from "../../src/assets/Edit_Pencil_01.svg";
import { ReactComponent as Trash } from "../../src/assets/Trash_Full.svg";
import download from "downloadjs";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(localeData);
dayjs.extend(weekday);
dayjs.extend(advancedFormat);

// ─── Styled Components ────────────────────────────────────────────────────────

const TabWrapper = styled.div`
  display: flex;
  gap: 0;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 20px;
  margin-top: 16px;
`;

/* Matches the existing approval page tab style (Leave Approvals, Timesheet Approvals, etc.) */
const TabButton = styled.button`
  background: none;
  border: none;
  border-bottom: 3px solid ${({ active }) => (active ? "#343535" : "transparent")};
  padding: 0 0 12px 0;
  margin-right: 32px;
  margin-bottom: -2px;
  font-size: 14px;
  font-weight: ${({ active }) => (active ? "600" : "400")};
  color: ${({ active }) => (active ? "#000000" : "#8c8c8c")};
  cursor: pointer;
  transition: all 0.5s ease;

  &:hover {
	color: #000000;
  }
`;

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
	width: 100% !important;
  }
  .ant-table-content {
	overflow-x: auto;
	white-space: nowrap;
  }
  .ant-table-cell {
	padding: 16px 20px;
  }
  .ant-table-thead .ant-table-cell {
	font-weight: bold;
	color: ${COLORS.SECONDARY_BLACK};
	white-space: nowrap;
  }
  .non-white {
	background: #f9f9f9;
  }
  .normal-column {
	min-width: 200px;
	white-space: normal;
  }
`;

/* WFH table uses exact same style as the Leave table — no borders, matches project style */
const WFHStyledTable = styled(Table)`
  padding-top: 20px;
  table {
	width: 100% !important;
  }
  .ant-table-content {
	overflow-x: auto;
	white-space: nowrap;
  }
  .ant-table-cell {
	padding: 20px;
  }
  .ant-table-thead .ant-table-cell {
	font-weight: bold;
	color: ${COLORS.SECONDARY_BLACK};
	white-space: nowrap;
  }
  .non-white {
	background: #f9f9f9;
  }
  .normal-column {
	min-width: 200px;
	white-space: normal;
  }
  .reason-column {
	min-width: 200px;
	white-space: normal;
  }
`;

const StyledApprovalSearchForm = styled(Form)`
  .ant-form-item-with-help {
	margin-bottom: 0px;
	.ant-form-item-explain-connected {
	  display: none;
	}
  }
  .ant-form-item {
	display: inline-block;
  }
  .outer-form {
	margin-right: 0px;
  }
  .ant-select-selector {
	max-width: 200px;
	min-width: 180px;
	margin-bottom: 10px;
	width: 100%;
  }
  .ant-select-clear {
	top: calc(50% - 5px);
	margin-top: 0;
	transform: translateY(-50%);
  }
`;

const ModalWrap = styled(Modal)`
  .ant-modal-content {
	border-radius: 14px;
	padding: 10px 8px;
  }
  .ant-modal-header {
	border-bottom: none;
	padding-bottom: 0;
  }
  .ant-modal-title {
	font-size: 20px;
	font-weight: 600;
	margin-top: -12px;
  }
  .top-icons {
	position: absolute;
	right: 55px;
	top: 18px;
	display: flex;
	gap: 18px;
	font-size: 18px;
	color: #5b6fd6;
	cursor: pointer;
  }
  .close-icon {
	position: absolute;
	right: 20px;
	top: 18px;
	font-size: 18px;
	cursor: pointer;
	color: #666;
  }
  .applied-tag {
	background: #e9ecfb;
	border-radius: 20px;
	padding: 3px 14px;
	font-size: 13px;
	margin-bottom: 18px;
	display: inline-block;
  }
  .label {
	color: #8b8b8b;
	font-weight: 500;
  }
  .value {
	color: #1f1f1f;
	font-weight: 500;
  }
  .attachment {
	color: #2d53da;
	cursor: pointer;
  }
  .reason-title {
	margin-top: 16px;
	color: #8b8b8b;
	font-weight: 500;
  }
  .reason-text {
	margin-top: 6px;
	color: #1f1f1f;
	line-height: 1.6;
  }
`;

const ActionWrapper = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;
  min-width: 60px;
`;

// ─── Main Component ───────────────────────────────────────────────────────────

function MyLeaveAndWFH({
	userRoleId,
	statusListFromID,
	selectedDepartmentId,
	userInfo,
	leaveCategoryList,
	ClientId,
	userList,
	roleList,
}) {
	const [hoveredRowId, setHoveredRowId] = useState(null);
	const menuList = useSelector(getMenuList);
	const Menulist = Array.isArray(menuList[userRoleId] || Object.values(menuList)[0])
		? menuList[userRoleId] || Object.values(menuList)[0]
		: [];

	const leaveReportAccess = Menulist.find((item) => item.key === "leavereport")?.access;
	const wfhReportAccess = Menulist.find((item) => item.key === "wfhreport")?.access;

	const [activeTab, setActiveTab] = useState(() => {
		if (leaveReportAccess) return "leave";
		if (wfhReportAccess) return "wfh";
		return "leave";
	});

	// ── Leave tab state ──────────────────────────────────────────────────────────
	const [leaveList, setLeaveList] = useState([]);
	const [allLeaveList, setAllLeaveList] = useState([]);
	const [CSVLeaveList, setCSVLeaveList] = useState([]);
	const [displayTaskLoader, setDisplayTaskLoader] = useState(false);
	const [leaveStatusId, setLeaveStatusId] = useState("0");
	const [CSVloader, setCSVLoader] = useState(false);
	const [leaveForm] = Form.useForm();
	const csvLinkEl = useRef();
	const leaveContainerRef = useRef(null);

	// ── WFH tab state ────────────────────────────────────────────────────────────
	const [wfhData, setWfhData] = useState([]);
	const [wfhViewData, setWfhViewData] = useState({});
	const [wfhOpen, setWfhOpen] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [wfhLoading, setWfhLoading] = useState(false);
	const [isDelete, setIsDelete] = useState(false);
	const [deleteLoading, setDeleteLoading] = useState(false);
	const [popupOpen, setPopupOpen] = useState(false);
	const [preview, setPreview] = useState(false);
	const [previewURL, setPreviewURL] = useState();
	const [CSVWfhList, setCSVWfhList] = useState([]);
	const wfhCsvLinkEl = useRef();
	const [wfhForm] = Form.useForm();
	const wfhContainerRef = useRef(null);
	const wfhDurationType = Form.useWatch("duration_type", wfhForm);
	const wfhStatusType = Form.useWatch("status", wfhForm);
	const pageTitleRef = useRef(null);
	const [scrollY, setScrollY] = useState(120);

	// ─── Helpers ─────────────────────────────────────────────────────────────────

	function weeks(days, date) {
		const newdate = new Date(date);
		newdate.setDate(newdate.getDate() + days);
		return newdate.toISOString().slice(0, 10);
	}

	// ─── LEAVE: data fetching ─────────────────────────────────────────────────────

	const data1 = leaveList?.filter(
		(val) =>
			val?.status_id === "4" ||
			(val?.status_id === "5" && val?.having_cancel_request === "1")
	);

	const data2 = leaveList?.filter(
		(val) =>
			val?.status_id === "5" &&
			(val?.having_cancel_request === "0" ||
				val?.having_cancel_request === "" ||
				!val?.having_cancel_request)
	);

	const availableLeaveCategories = allLeaveList?.reduce((acc, item) => {
		if (
			item.leave_category_id &&
			!acc.some((a) => a.leave_category_id === item.leave_category_id)
		) {
			acc.push({
				leave_category_id: item.leave_category_id,
				leave_category_name: item.leave_category_name,
			});
		}
		return acc;
	}, []);

	const getLeaveList = async () => {
		return new Promise(async (resolve, reject) => {
			setLeaveList([]);
			const { status_id, start_date, duration_type, month, end_date } =
				leaveForm.getFieldsValue();
			const year = dateInDetail(getKenyanDateTime()).year;

			if (status_id !== undefined) {
				setLeaveStatusId(status_id);
				setDisplayTaskLoader(true);

				const payload = {
					status_id:
						status_id === "0" ? "" : status_id === "4" ? "4,5" : status_id,
					officesupervisorid: [""],
					selected_role_id: userRoleId,
					show_my_leave: true,
				};

				if (duration_type === 1 && start_date && end_date) {
					payload.start_date = getMySqlDate(start_date);
					payload.end_date = getMySqlDate(end_date);
				} else if (duration_type === 2 && typeof month === "number") {
					const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
						year,
						month
					);
					payload.start_date = moment(startDateOfMonth).format("YYYY-MM-DD");
					payload.end_date = moment(lastDateOfMonth).format("YYYY-MM-DD");
				} else if (duration_type === 3) {
					payload.start_date = getMySqlDate(start_date);
					payload.end_date = weeks(7, getMySqlDate(start_date));
				} else if (duration_type === 4) {
					payload.start_date = momentDate(addMonthinDate(getinitialdate()));
					payload.end_date = momentDate(addMonthinDate(getKenyanDateTime(), 3));
				}

				const { code, leaves = [] } = await CALL_API(
					`leave-list/${ClientId}`,
					"post",
					payload
				);

				setDisplayTaskLoader(false);

				if (includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)) {
					const filteredLeaves = leaves.filter(
						(item) => item.userid === userInfo.userid
					);
					setAllLeaveList(filteredLeaves);

					const leaveType = leaveForm.getFieldValue("leave_type");
					if (!leaveType) {
						setLeaveList(filteredLeaves);
					} else {
						setLeaveList(
							filteredLeaves.filter(
								(item) => item.leave_category_id === leaveType
							)
						);
					}
					resolve(filteredLeaves);
				} else {
					reject([]);
				}
			} else {
				resolve([]);
			}
		});
	};

	useEffect(() => {
		leaveForm.setFieldsValue({ month: moment().month() + 1 });
		getLeaveList().catch(() => { });
	}, [selectedDepartmentId, userRoleId]);

	// ─── WFH: data fetching ───────────────────────────────────────────────────────

	const getWfhData = async () => {
		try {
			setWfhLoading(true);

			const formValues = wfhForm.getFieldsValue();
			const duration_type = formValues.duration_type ?? 4;
			const start_date = formValues.start_date;
			const end_date = formValues.end_date;
			const month = formValues.month;
			const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
				dateInDetail(getKenyanDateTime()).year,
				get(
					find(MONTH_LIST, { value: month || dayjs().format("MMMM") }),
					"index",
					dayjs().month()
				)
			);
			const status = formValues.status ?? "0";

			const startDate = getMySqlDate(
				duration_type === 2
					? startDateOfMonth
					: duration_type === 4
						? startDateOfMonth
						: dayjs(start_date).format("YYYY-MM-DD")
			);
			const endDate = getMySqlDate(
				duration_type === 2
					? lastDateOfMonth
					: duration_type === 3
						? weeks(7, getMySqlDate(start_date))
						: duration_type === 4
							? lastDateOfMonth
							: dayjs(end_date).format("YYYY-MM-DD")
			);

			const currentUserRecord = userList?.find(
				(u) => u?.userid === userInfo?.userid
			);

			const payload = {
				requestType: "mine",
				userId: userInfo?.userid || "",
				country: userInfo?.managingoffice?.[0] || currentUserRecord?.country || "",
				startDate,
				endDate,
				statusId: status,
			};

			const { status: apiStatus, response } = await CALL_FEATCH_API(
				`wfh/getwfhrequest`,
				"post",
				payload
			);

			if (apiStatus === "SUCCESS") {
				const mapped = (response || []).map((item) => ({
					...item,
					wfhStartDate: item?.startDate,
					wfhEndDate: item?.endDate,
					wfhNoofDays: item?.noOfDays,
					wfhReason: item?.reason,
					requestId: item?.wfhId,
					fileName: item?.attachedDocuments?.[0]?.fileName || "",
					objectKey: item?.attachedDocuments?.[0]?.objectKey || "",
					reportingManager: item?.officeSupervisorId,
					approved_rejected_byName: item?.officesupervisor || item?.approved_rejected_byName || "",
					rejectReason: typeof item?.requestType === "object" ? item?.requestType?.decline_reason || "" : "",
				}));
				setWfhData(mapped);
			} else {
				setWfhData([]);
			}
		} catch (err) {
			console.error("getWfhData error →", err);
			message.error("Failed to fetch WFH requests");
		} finally {
			setWfhLoading(false);
		}
	};

	useEffect(() => {
		getWfhData();
	}, [wfhForm, userInfo]);

	// ─── WFH: delete ─────────────────────────────────────────────────────────────

	const handleWfhDelete = async () => {
  try {
	setDeleteLoading(true);

	const payload = {
	  userId: userInfo?.userid || "",
	  wfhId: wfhViewData?.requestId, // use selected record
	};

	const { code,status } = await CALL_FEATCH_API(
	  "/wfh/deletewfhrequest",
	  "delete",
	  payload
	);

	if (status === STATUS_CODE.SUCCESS) {
	  setIsDelete(false);
	  setWfhViewData({});
	  setPopupOpen(true);

	  setTimeout(() => {
		setPopupOpen(false);
	  }, 2000);

	  await getWfhData();
	} else {
	  message.error("Failed to delete WFH request.");
	}
  } catch (error) {
	console.error("Delete WFH Error:", error);
	message.error("Something went wrong while deleting the WFH request.");
  } finally {
	setDeleteLoading(false);
  }
};

	// ─── WFH: file preview ────────────────────────────────────────────────────────

	const handlePreviewClick = async (record) => {
		try {
			const ext = record?.fileName?.split(".")?.pop();
			setWfhLoading(true);
			const { url,status,response  } = await CALL_FEATCH_API(
				`document-list/${ClientId}`,
				"post",
				{
					method: "preview-wfh-document",
					userId: record?.userId || "",
					wfhId: record?.requestId,
					fileKey: record?.objectKey || "",
				}
			);
			if (status === "SUCCESS" || response?.code === "SUCCESS") {
				if (["jpg", "jpeg", "png", "svg", "pdf"].includes(ext)) {
					setPreviewURL(response?.url);
					setPreview(true);
				} else {
					download(url);
				}
			} else {
				message.error("Preview failed. Try again.");
			}
		} catch (err) {
			message.error("Something went wrong");
		} finally {
			setWfhLoading(false);
		}
	};

	// ─── Scroll height ────────────────────────────────────────────────────────────

	useEffect(() => {
		if (!pageTitleRef.current) return;
		const calculateScrollY = () => {
			if (!pageTitleRef.current) return; // guard: node gone when tab is hidden
			const headerHeight = pageTitleRef.current.offsetHeight;
			const availableHeight = window.innerHeight - headerHeight - 300;
			setScrollY(Math.max(120, availableHeight));
		};
		calculateScrollY();
		const ro = new ResizeObserver(calculateScrollY);
		ro.observe(pageTitleRef.current);
		window.addEventListener("resize", calculateScrollY);
		return () => {
			ro.disconnect();
			window.removeEventListener("resize", calculateScrollY);
		};
	}, [activeTab]); // ← add activeTab so it re-runs when the WFH tab mounts

	// ─── Leave: CSV ───────────────────────────────────────────────────────────────

	const getEffectiveDate = (newDate, originalDate, format) => {
		const d =
			!newDate || newDate === "null" || newDate === "" ? originalDate : newDate;
		return moment(d).format(format);
	};

	const getApproverName = (approvedRejectedBy) => {
		const user = userList?.find(
			(val) =>
				val?.userid === approvedRejectedBy ||
				val?.employeeid === approvedRejectedBy ||
				val?.email === approvedRejectedBy
		);
		return user?.fullname || approvedRejectedBy || "-";
	};

	const getCSVHeaders = () => {
		const baseHeaders = [
			{ label: "Leave Type", key: "Leave Type" },
			{ label: "Name", key: "Name" },
			{ label: "Start Date", key: "Start Date" },
			{ label: "Start Day", key: "Start Day" },
			{ label: "End Date", key: "End Date" },
			{ label: "End Day", key: "End Day" },
			{ label: "Days", key: "Days" },
		];
		if (leaveStatusId === "5")
			return [
				...baseHeaders,
				{ label: "Approved by", key: "Approved by" },
				{ label: "Description", key: "Description" },
			];
		if (leaveStatusId === "6")
			return [
				...baseHeaders,
				{ label: "Rejected by", key: "Rejected by" },
				{ label: "Decline Reason", key: "Decline Reason" },
			];
		return [...baseHeaders, { label: "Description", key: "Description" }];
	};

	const prepareLeaveCSV = async () => {
		setCSVLoader(true);
		const sourceData =
			leaveStatusId === "4" ? data1 : leaveStatusId === "5" ? data2 : leaveList;
		if (sourceData.length > 0) {
			setCSVLeaveList(
				reduce(
					sourceData,
					(acc, leave) => {
						const base = {
							"Leave Type": leave.leave_category_name,
							Name: leave.fullname,
							"Start Date": getEffectiveDate(leave.new_start_date, leave.start_date, "Do MMM YYYY"),
							"Start Day": getEffectiveDate(leave.new_start_date, leave.start_date, "dddd"),
							"End Date": getEffectiveDate(leave.new_end_date, leave.end_date, "Do MMM YYYY"),
							"End Day": getEffectiveDate(leave.new_end_date, leave.end_date, "dddd"),
							Days:
								!leave.new_number_of_days ||
									leave.new_number_of_days === "null" ||
									leave.new_number_of_days === ""
									? leave.number_of_days
									: leave.new_number_of_days,
						};
						if (leaveStatusId === "5") {
							acc.push({ ...base, "Approved by": getApproverName(leave.approved_rejected_by), Description: leave.reason });
						} else if (leaveStatusId === "6") {
							acc.push({ ...base, "Rejected by": getApproverName(leave.approved_rejected_by), "Decline Reason": leave.decline_reason });
						} else {
							acc.push({ ...base, Description: leave.reason });
						}
						return acc;
					},
					[]
				)
			);
			setTimeout(() => csvLinkEl.current.link.click());
		} else {
			message.error("No data available to download.");
		}
		setCSVLoader(false);
	};

	// ─── WFH: CSV ─────────────────────────────────────────────────────────────────

	const prepareWfhCSV = async () => {
		if (wfhData?.length > 0) {
			const csvData = wfhData.map((item) => {
				const base = {
					"Start Date": item?.wfhStartDate ? dayjs(item.wfhStartDate).format("Do MMM YYYY - ddd") : "-",
					"End Date": item?.wfhEndDate ? dayjs(item.wfhEndDate).format("Do MMM YYYY - ddd") : "-",
					"Total Days": item?.wfhNoofDays || "-",
					"Applied on": item?.createdAt ? dayjs(item.createdAt).format("Do MMM YYYY - ddd") : "-",
					"Reason for WFH": item?.wfhReason || "-",
				};
				if (wfhStatusType === "1") base["Approved by"] = item?.approved_rejected_byName || "-";
				if (wfhStatusType === "2") {
					base["Rejected by"] = item?.approved_rejected_byName || "-";
					base["Decline Reason"] = item?.rejectReason || "-";
				}
				return base;
			});
			setCSVWfhList(csvData);
			setTimeout(() => wfhCsvLinkEl.current.link.click());
		} else {
			message.error("No data available to download.");
		}
	};

	// ─── Leave columns ────────────────────────────────────────────────────────────

	const validateDateRange = (date) => {
		const endDate = leaveForm.getFieldValue("end_date");
		if (endDate && moment(endDate).isBefore(date)) {
			leaveForm.setFieldsValue({ end_date: date });
		}
	};

	const leaveColumns = [
		{
			title: "Leave Type",
			dataIndex: "leave_category_name",
			key: "leave_category_name",
			width: "10%",
		},
		{
			title: "Name",
			dataIndex: "fullname",
			key: "fullname",
			width: "10%",
		},
		{
			title: "Start Date",
			dataIndex: "start_date",
			key: "start_date",
			width: "10%",
			render: (_, record) => {
				const d = !record.new_start_date || record.new_start_date === "null" || record.new_start_date === "" ? record.start_date : record.new_start_date;
				return moment(d).format("DD MMM YYYY");
			},
			sorter: (a, b) => {
				const dA = !a.new_start_date || a.new_start_date === "null" || a.new_start_date === "" ? moment(a.start_date) : moment(a.new_start_date);
				const dB = !b.new_start_date || b.new_start_date === "null" || b.new_start_date === "" ? moment(b.start_date) : moment(b.new_start_date);
				return dA - dB;
			},
		},
		{
			title: "Start Day",
			dataIndex: "start_date",
			key: "start_day",
			width: "10%",
			render: (_, record) => {
				const d = !record.new_start_date || record.new_start_date === "null" || record.new_start_date === "" ? record.start_date : record.new_start_date;
				return moment(d).format("dddd");
			},
		},
		{
			title: "End Date",
			dataIndex: "end_date",
			key: "end_date",
			width: "10%",
			render: (_, record) => {
				const d = !record.new_end_date || record.new_end_date === "null" || record.new_end_date === "" ? record.end_date : record.new_end_date;
				return moment(d).format("DD MMM YYYY");
			},
			sorter: (a, b) => {
				const dA = !a.new_end_date || a.new_end_date === "null" || a.new_end_date === "" ? moment(a.end_date) : moment(a.new_end_date);
				const dB = !b.new_end_date || b.new_end_date === "null" || b.new_end_date === "" ? moment(b.end_date) : moment(b.new_end_date);
				return dA - dB;
			},
		},
		{
			title: "End Day",
			dataIndex: "end_date",
			key: "end_day",
			width: "10%",
			render: (_, record) => {
				const d = !record.new_end_date || record.new_end_date === "null" || record.new_end_date === "" ? record.end_date : record.new_end_date;
				return moment(d).format("dddd");
			},
		},
		{
			title: "Days",
			dataIndex: "number_of_days",
			key: "number_of_days",
			width: "10%",
			render: (_, record) => {
				const n = record?.new_number_of_days;
				if (n !== null && n !== undefined && n !== "" && n !== "null" && n !== "undefined") return n;
				return record?.number_of_days || "-";
			},
		},
	];

	if (leaveStatusId === "5") {
		leaveColumns.push({
			title: "Approved by",
			dataIndex: "approved_rejected_by",
			key: "approved_rejected_by",
			width: "10%",
			render: (value) => {
				const user = userList?.find((val) => val?.userid === value || val?.employeeid === value || val?.email === value);
				return user?.fullname || value || "-";
			},
		});
	}

	if (leaveStatusId === "6") {
		leaveColumns.push(
			{
				title: "Rejected by",
				dataIndex: "approved_rejected_by",
				key: "rejected_by",
				width: "10%",
				render: (value) => {
					const user = userList?.find((val) => val?.userid === value || val?.employeeid === value || val?.email === value);
					return user?.fullname || value || "-";
				},
			},
			{
				title: "Decline Reason",
				dataIndex: "decline_reason",
				key: "decline_reason",
				width: "10%",
				className: "normal-column",
				render: (reason) => <ViewMore value={reason} />,
			}
		);
	} else {
		leaveColumns.push({
			title: "Description",
			dataIndex: "reason",
			key: "reason",
			width: "30%",
			className: "normal-column",
			render: (reason) => <ViewMore value={reason} />,
		});
	}

	// ─── WFH columns ─────────────────────────────────────────────────────────────

	const wfhColumns = [
		{
			title: "Start Date - Day",
			dataIndex: "wfhStartDate",
			key: "wfhStartDate",
			width: 150,
			render: (date) => dayjs(date)?.format("Do MMM YYYY - ddd"),
		},
		{
			title: "End Date - Day",
			dataIndex: "wfhEndDate",
			key: "wfhEndDate",
			width: 150,
			render: (date) => dayjs(date)?.format("Do MMM YYYY - ddd"),
		},
		{
			title: "Total Days",
			dataIndex: "wfhNoofDays",
			key: "wfhNoofDays",
			width: 150,
		},
		{
			title: "Applied on",
			dataIndex: "createdAt",
			key: "createdAt",
			width: 150,
			render: (date) => dayjs(date)?.format("Do MMM YYYY - ddd"),
		},
		{
			title: "Attachment",
			dataIndex: "fileName",
			key: "fileName",
			width: 150,
			render: (text, record) =>
				text ? (
					<a
						style={{ color: "#2d53da" }}
						onClick={(e) => { e.stopPropagation(); handlePreviewClick(record); }}
					>
						{text}
					</a>
				) : "-",
		},
		{
			title: "Reason for WFH",
			dataIndex: "wfhReason",
			key: "wfhReason",
			width: 150,
			className: "reason-column",
		},
		{
			key: "actions",
			width: 100,
			render: (_, record) =>
				record?.statusId === "0" ? (
					<ActionWrapper
						style={{
							opacity: hoveredRowId === record?.requestId ? 1 : 0,
							visibility: hoveredRowId === record?.requestId ? "visible" : "hidden",
							transition: "opacity 0.3s ease",
						}}
					>						{Menulist?.find((item) => item?.key === "leavereport" && item?.permission?.edit) && (
						<Edit
							style={{
								cursor: "pointer",
								background:"#C2FAE5",								
								padding:"2px",
								borderRadius:"4px"
							}}
							onClick={(e) => {
								e.stopPropagation();
								setIsEdit(true);
								setWfhViewData(record);
							}}
						/>
					)}
						{Menulist?.find((item) => item?.key === "leavereport" && item?.permission?.delete) && (
							<Trash
								style={{
									cursor: "pointer",
								background:"#C2FAE5",								
								padding:"2px",
								borderRadius:"4px"
									
								}}
								onClick={(e) => {
									e.stopPropagation();
									setIsDelete(true);
									setWfhViewData(record);
								}}
							/>
						)}
					</ActionWrapper>
				) : null,
		},
	];

	if (wfhStatusType === "1") {
		wfhColumns.push({
			title: "Approved by",
			dataIndex: "approved_rejected_byName",
			key: "approved_rejected_byName",
			width: 150,
			render: (text) => text || "-",
		});
	}
	if (wfhStatusType === "2") {
		wfhColumns.push(
			{ title: "Rejected by", dataIndex: "approved_rejected_byName", key: "approved_rejected_byName", width: 150, render: (text) => text || "-" },
			{ title: "Decline Reason", dataIndex: "rejectReason", key: "rejectReason", width: 150, className: "normal-column", render: (reason) => <ViewMore value={reason || "-"} /> }
		);
	}

	const validateWfhDateRange = () => {
		const end = dayjs(wfhForm.getFieldValue("end_date"));
		const start = dayjs(wfhForm.getFieldValue("start_date"));
		if (start.isAfter(end)) { wfhForm.setFieldsValue({ end_date: start }); getWfhData(); }
	};

	const validateWfhEndDateRange = () => {
		const start = dayjs(wfhForm.getFieldValue("start_date"));
		const end = dayjs(wfhForm.getFieldValue("end_date"));
		if (end.isBefore(start)) { wfhForm.setFieldsValue({ start_date: end }); getWfhData(); }
	};

	const tableDataSource =
		leaveStatusId === "4" ? data1 : leaveStatusId === "5" ? data2 : leaveList;

	// ─── Render ───────────────────────────────────────────────────────────────────

	return (
		<div>
			{/* ── Tab Header ── */}
			<Row className="page-title" style={{ marginBottom: 0 }}>
				<Col span={12} className="page-title-head">
					My History
				</Col>
				<Col span={12} className="align-right">
					{activeTab === "leave" ? (
						<>
							<ButtonOutlined onClick={prepareLeaveCSV}>
								{CSVloader ? "Generating CSV file..." : "Export CSV file"}
							</ButtonOutlined>
							<CSVLink
								headers={getCSVHeaders()}
								data={CSVLeaveList}
								filename="My Leave Report.csv"
								asyncOnClick={true}
								ref={csvLinkEl}
							/>
						</>
					) : (
						<>
							<ButtonOutlined onClick={prepareWfhCSV} disabled={wfhData.length === 0}>
								Export CSV file
							</ButtonOutlined>
							<CSVLink
								data={CSVWfhList}
								filename="workfromhome.csv"
								asyncOnClick={true}
								ref={wfhCsvLinkEl}
							/>
						</>
					)}
				</Col>
			</Row>

			{/* ── Tabs ── */}
			<TabWrapper>
				{leaveReportAccess && (
					<TabButton active={activeTab === "leave"} onClick={() => setActiveTab("leave")}>
						Leave
					</TabButton>
				)}
				{wfhReportAccess && (
					<TabButton active={activeTab === "wfh"} onClick={() => setActiveTab("wfh")}>
						Work From Home
					</TabButton>
				)}
			</TabWrapper>

			{/* ══════════════════ LEAVE TAB ══════════════════ */}
			{activeTab === "leave" && (
				<>
					<Row className="page-title">
						<Col xs={24} sm={19} md={19} className="page-title-head" ref={leaveContainerRef}>
							<Space>
								<StyledApprovalSearchForm
									form={leaveForm}
									name="approval_form"
									layout="inline"
									initialValues={{
										duration_type: 4,
										month: moment().month() + 1,
										status_id: "0",
										start_date: momentDate(addMonthinDate(getKenyanDateTime(), -1)),
										end_date: momentDate(addDaysinDate(getKenyanDateTime())),
										leave_type: undefined,
									}}
									onValuesChange={(changedValues) => {
										if (changedValues.duration_type === 2) {
											leaveForm.setFieldsValue({ month: moment().month() + 1 });
											setTimeout(() => getLeaveList(), 0);
										} else {
											getLeaveList();
										}
									}}
								>
									<Form.Item name="status_id" rules={[{ required: true, message: "" }]}>
										<Select
											placeholder="Select..."
											fieldNames={{ label: "status_name", value: "status_id" }}
											options={concat(
												{ status_id: "0", status_name: "All" },
												orderBy(statusListFromID, [(val) => val.status_id], ["asc"])
											)}
											getPopupContainer={() => leaveContainerRef.current}
										/>
									</Form.Item>

									<Form.Item name="duration_type" rules={[{ required: true, message: "" }]}>
										<Select
											placeholder="Select..."
											options={APPROVAL_FILTER_TYPES}
											getPopupContainer={() => leaveContainerRef.current}
										/>
									</Form.Item>

									<Form.Item className="outer-form" shouldUpdate>
										{({ getFieldValue }) => {
											const dt = getFieldValue("duration_type");
											return dt === 1 ? (
												<Row>
													<Col ref={leaveContainerRef}>
														<Form.Item name="start_date" rules={[() => ({ validator(_, value) { return moment(value).isValid() ? Promise.resolve() : Promise.reject(); } })]}>
															<DatePicker placeholder="Start date" format="DD-MM-YYYY" onChange={validateDateRange} allowClear={false} getPopupContainer={() => leaveContainerRef.current} />
														</Form.Item>
													</Col>
													<Col ref={leaveContainerRef}>
														<Form.Item name="end_date" rules={[() => ({ validator(_, value) { return moment(value).isValid() ? Promise.resolve() : Promise.reject(); } })]}>
															<DatePicker placeholder="End date" format="DD-MM-YYYY" onChange={validateDateRange} allowClear={false} getPopupContainer={() => leaveContainerRef.current} />
														</Form.Item>
													</Col>
												</Row>
											) : dt === 3 ? (
												<Form.Item name="start_date" rules={[() => ({ validator(_, value) { return moment(value).isValid() ? Promise.resolve() : Promise.reject(); } })]}>
													<DatePicker placeholder="Start date" format="DD-MM-YYYY" onChange={validateDateRange} allowClear={false} getPopupContainer={() => leaveContainerRef.current} />
												</Form.Item>
											) : dt === 2 ? (
												<Form.Item name="month" rules={[{ required: true, message: "" }]}>
													<Select
														placeholder="Select month"
														options={MONTH_LIST.map((m) => ({ label: m.label, value: m.index }))}
														getPopupContainer={() => leaveContainerRef.current}
													/>
												</Form.Item>
											) : null;
										}}
									</Form.Item>

									<Form.Item name="leave_type">
										<Select
											showSearch
											allowClear
											placeholder="All Categories"
											optionFilterProp="label"
											filterOption={(input, option) => option.label?.toLowerCase().includes(input.toLowerCase())}
											options={availableLeaveCategories}
											fieldNames={{ label: "leave_category_name", value: "leave_category_id" }}
											getPopupContainer={() => leaveContainerRef.current}
										/>
									</Form.Item>
								</StyledApprovalSearchForm>
							</Space>
						</Col>
					</Row>

					<Spin spinning={displayTaskLoader}>
						<StyledTable
							dataSource={tableDataSource}
							columns={leaveColumns}
							rowClassName={(_, index) => (index % 2 === 0 ? "" : "non-white")}
							rowKey="user_leave_id"
						/>
					</Spin>
				</>
			)}

			{/* ══════════════════ WFH TAB ══════════════════ */}
			{activeTab === "wfh" && (
				<>
					<div ref={pageTitleRef}>
						<Form
							form={wfhForm}
							layout="vertical"
							initialValues={{
								status: "0",
								duration_type: 4,
								month: dateInDetail(getKenyanDateTime()).monthName,
								start_date: dayjs(),
								end_date: dayjs(),
							}}
							onValuesChange={getWfhData}
						>
							<Row gutter={16}>
								<Col xs={24} sm={12} md={8} lg={4} ref={wfhContainerRef}>
									<Form.Item name="status">
										<Select
											placeholder="Status"
											options={[
												{ label: "Waiting For Approval", value: "0" },
												{ label: "Approved", value: "1" },
												{ label: "Rejected", value: "2" },
											]}
											getPopupContainer={() => wfhContainerRef.current}
										/>
									</Form.Item>
								</Col>

								<Col xs={24} sm={12} md={8} lg={4} ref={wfhContainerRef}>
									<Form.Item name="duration_type">
										<Select
											placeholder="Select..."
											options={APPROVAL_FILTER_TYPES}
											getPopupContainer={() => wfhContainerRef.current}
										/>
									</Form.Item>
								</Col>

								{wfhDurationType === 1 && (
									<>
										<Col xs={24} sm={12} md={8} lg={4} ref={wfhContainerRef}>
											<Form.Item name="start_date">
												<DatePicker placeholder="Start date" format="DD-MM-YYYY" className="w-100" allowClear onChange={validateWfhDateRange} getPopupContainer={() => wfhContainerRef.current} />
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={8} lg={4} ref={wfhContainerRef}>
											<Form.Item name="end_date">
												<DatePicker placeholder="End date" format="DD-MM-YYYY" className="w-100" allowClear onChange={validateWfhEndDateRange} getPopupContainer={() => wfhContainerRef.current} />
											</Form.Item>
										</Col>
									</>
								)}

								{wfhDurationType === 2 && (
									<Col xs={24} sm={12} md={8} lg={4} ref={wfhContainerRef}>
										<Form.Item name="month">
											<Select placeholder="Select..." options={MONTH_LIST} getPopupContainer={() => wfhContainerRef.current} />
										</Form.Item>
									</Col>
								)}
							</Row>
						</Form>
					</div>

					<Spin spinning={wfhLoading}>
						<WFHStyledTable
							columns={wfhColumns}
							dataSource={wfhData}
							pagination={false}
							scroll={{ y: scrollY }}
							style={{ minHeight: scrollY + 50 }}
							rowClassName={(_, index) => (index % 2 ? "non-white" : "")}
							onRow={(record) => ({
								onClick: (e) => {
									e.stopPropagation();
									setWfhOpen(true);
									setWfhViewData(record);
								},
								onMouseEnter: () => setHoveredRowId(record?.requestId),
								onMouseLeave: () => setHoveredRowId(null),
							})}
						/>
					</Spin>

					{/* WFH View Modal */}
					<ModalWrap
						open={wfhOpen}
						onCancel={() => { setWfhOpen(false); setWfhViewData({}); }}
						footer={null}
						centered
						width={520}
						closable={false}
						title="WFH Request"
					>
						{wfhViewData?.statusId === "0" && (
							<div className="top-icons">
								<Edit style={{ background: "#C2FAE5", padding: "2px", borderRadius: "4px" }} onClick={(e) => { e.stopPropagation(); setWfhOpen(false); setIsEdit(true); }} />
								<Trash style={{ background: "#C2FAE5", padding: "2px", borderRadius: "4px" }} onClick={(e) => { e.stopPropagation(); setWfhOpen(false); setIsDelete(true); }} />
							</div>
						)}
						<CloseOutlined className="close-icon" onClick={() => { setWfhOpen(false); setWfhViewData({}); }} />

						<div className="applied-tag">
							Applied on&nbsp;&nbsp;
							<b className="value">{dayjs(wfhViewData?.createdAt).format("Do MMM, YYYY")}</b>
						</div>

						<Row gutter={[8, 14]}>
							<Col xs={24} sm={12}><div className="label">Start Date</div></Col>
							<Col xs={24} sm={12}><div className="value">{dayjs(wfhViewData?.wfhStartDate)?.format("Do MMM YYYY - ddd")}</div></Col>

							<Col xs={24} sm={12}><div className="label">End Date</div></Col>
							<Col xs={24} sm={12}><div className="value">{dayjs(wfhViewData?.wfhEndDate)?.format("Do MMM YYYY - ddd")}</div></Col>

							<Col xs={24} sm={12}><div className="label">Total Days</div></Col>
							<Col xs={24} sm={12}><div className="value">{wfhViewData?.wfhNoofDays}</div></Col>

							<Col xs={24} sm={12}><div className="label">Attachment</div></Col>
							<Col xs={24} sm={12}>
								<div className="value attachment" onClick={() => { setWfhOpen(false); handlePreviewClick(wfhViewData); }}>
									{wfhViewData?.fileName || "-"}
								</div>
							</Col>
						</Row>

						<div className="reason-title">Reason for WFH</div>
						<div className="reason-text">{wfhViewData?.wfhReason}</div>
					</ModalWrap>

					{/* Edit WFH */}
					<ApplyWorkFromHome
						open={isEdit}
						onCancel={() => { setIsEdit(false); setWfhViewData({}); }}
						data={wfhViewData}
						getData={getWfhData}
					/>

					{/* Delete WFH */}
					<Modal
						open={isDelete}
						footer={null}
						centered
						closable={false}
						width={420}
						onCancel={() => { setIsDelete(false); setWfhViewData({}); }}
					>
						<div>Are you sure you want to delete this work from home request?</div>
						<div className="w-100 text-end mt-3">
							<ButtonOutlined onClick={() => { setIsDelete(false); setWfhViewData({}); }}>Cancel</ButtonOutlined>
							<ButtonFilled onClick={handleWfhDelete} loading={deleteLoading}>Delete</ButtonFilled>
						</div>
					</Modal>

					<SuccessDeclinePopup open={popupOpen} setOpen={setPopupOpen} type="success" message="Deleted" />

					<ViewDocument
						open={preview}
						onCancel={() => { setPreview(false); setPreviewURL(""); }}
						data={previewURL}
					/>
				</>
			)}
		</div>
	);
}


const mapStateToProps = (state) => ({
	userRoleId: getUserRoleId(state),
	statusListFromID: getStatusListFromID(state, ["4", "5", "6"]),
	selectedDepartmentId: getSelectedDepartmentId(state),
	userInfo: getUserInfo(state),
	leaveCategoryList: getLeaveCategoryList(state),
	ClientId: getClientid(state),
	userList: getUserList(state),
	roleList: getRoleList(state),
});

const mapDispatchToProps = (dispatch) =>
	bindActionCreators({ updateProcessingModal: toggleProcessingModal }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps, null)(MyLeaveAndWFH);